import React from "react"
import CTA from "../../components/CTA"
import { Container } from "@material-ui/core"
import Layout from "../../components/Layout"

import Hero from "./../../components/Hero"


import adv from "../../assets/services/data/advanced-analytics.png"

// import warehousing from '../../assets/services/data/data-warehousing.png'
// import adv_analytics from '../../assets/services/data/advanced-analytics.png'

// import benefits from '../../assets/services/data/benefits-of data-management.png'




function Page() {
  return (
    <Layout
      cssClass="data-man services--page"
      title="INVIZ AI Solutions | Data Management Analytics"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >

      <Hero>
        <p className="xlarge">Futureproof your company by becoming a data driven organisation</p>
      </Hero>    
      
      <section>
      <Container>
        <div className="text-center">
        <p>At Inviz, we believe that truly functional data systems are those that not only caters to the existing requirements, but also to possible future needs. Keeping this in mind, we design enterprise architecture such that the most significant data points are captured and remain usable at scale for complex business requirements.</p> 
        </div>
        <br />
        <header className="centered">
          <h3><strong>Inviz’s Data <span className="green">Management Services</span></strong></h3>
        </header>
        <ul className="flex">
          <li className="xs-12 sm-4"><div>
            <h4><b>Data Consulting</b></h4>
            <ul className="bullets_">
                  <li><b></b><span>Identify key Business Areas that can benefit from data and analytics best practices.</span></li>
                  <li><b></b><span>Build the right data strategy including manpower & Infrastructure planning.</span></li>
                  <li><b></b><span>Develop roadmap for data strategy Implementation.</span></li>
            </ul>
            </div>
            </li>
          <li className="xs-12 sm-4"><div><h4><b>Data
Platform </b></h4>
            <ul className="bullets_">
                  <li><b></b><span>Estimate infrastructure requirements, and capacity planning.</span></li>
                  <li><b></b><span>Build customized data platforms for your business requirements.</span></li>
                  <li><b></b><span>Setup data governance & security best practices.</span></li>
            </ul>
</div></li>
          <li className="xs-12 sm-4"><div>
            <h4><b>Data
Applications</b></h4>
            <ul className="bullets_">
                  <li><b></b><span>Building pipelines for data collection & storage from various sources.</span></li>
                  <li><b></b><span>Develop dashboards for analytics.</span></li>
                  <li><b></b><span>Develop data applications that enables data driven decisions.</span></li>
            </ul>
</div></li>
        </ul>
        </Container>
      </section>


      <section className="advanced-analytics">
        <Container>
          <header>
          <h3>
            <strong>Advanced <span className="green">Analytics</span></strong>
          </h3>
          </header>
          <ul >
            <li>              
              <figure>
              <img src={adv} alt="advanced analytics"/>
              </figure>             
            </li>
            <li>
            <div className="text">
          <p>We work with companies on building an <b className="green">end to end metrics dashboard</b>.</p>
          <p>            
            We focus both on <b className="green">what to measure</b> &amp; <b className="green">when to measure</b>, starting from technology metrics all the way to business metrics, ensuring that there is continuous visibility, proper alert mechanisms, and the ability to identify levers that needs to be fixed in case some business function is not performing optimally.
          </p>
          </div>
            </li>  
            </ul>
        </Container>
      </section>
      <CTA>
      If you feel, we could help <b className="green">solve your business problem</b>,         
      </CTA>
    </Layout>
  )
}

export default Page
